// pages/About/styles.js
import styled from "styled-components";
import { motion } from "framer-motion";

export const AboutWrapper = styled.div`
	min-height: calc(100vh - 64px);
	background: ${(props) => props.theme.colors.background.alt};
`;

export const HeroSection = styled.div`
	background: ${(props) => props.theme.colors.primary.main};
	color: white;
	padding: ${(props) => props.theme.spacing["4xl"]} 0;
	margin-bottom: ${(props) => props.theme.spacing["4xl"]};
`;

export const HeroContent = styled.div`
	max-width: 800px;
	margin: 0 auto;
	margin-top: 60px;
	text-align: center;
	padding: 0 ${(props) => props.theme.spacing.xl};

	h1 {
		font-size: ${(props) => props.theme.typography.sizes["4xl"]};
		font-weight: ${(props) => props.theme.typography.weights.bold};
		margin-bottom: ${(props) => props.theme.spacing.lg};
	}

	p {
		font-size: ${(props) => props.theme.typography.sizes.xl};
		opacity: 0.9;
	}
`;

export const Section = styled.section`
	padding: ${(props) => props.theme.spacing["3xl"]} 0;
`;

export const TeamGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(1, 1fr);
	gap: ${(props) => props.theme.spacing.xl};
	margin-top: ${(props) => props.theme.spacing.xl};

	@media (min-width: ${(props) => props.theme.breakpoints.sm}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: ${(props) => props.theme.breakpoints.lg}) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const TeamMember = styled(motion.div)`
	text-align: center;

	img {
		width: 200px;
		height: 200px;
		border-radius: 50%;
		margin-bottom: ${(props) => props.theme.spacing.lg};
		object-fit: cover;
	}

	h3 {
		font-size: ${(props) => props.theme.typography.sizes.lg};
		font-weight: ${(props) => props.theme.typography.weights.semibold};
		margin-bottom: ${(props) => props.theme.spacing.xs};
	}

	p {
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;

export const ValuesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(1, 1fr);
	gap: ${(props) => props.theme.spacing.xl};
	margin-top: ${(props) => props.theme.spacing.xl};

	@media (min-width: ${(props) => props.theme.breakpoints.sm}) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const ValueCard = styled(motion.div)`
	background: ${(props) => props.theme.colors.background.main};
	padding: ${(props) => props.theme.spacing.xl};
	border-radius: ${(props) => props.theme.borderRadius.lg};
	box-shadow: ${(props) => props.theme.shadows.md};

	.icon {
		width: 48px;
		height: 48px;
		border-radius: ${(props) => props.theme.borderRadius.md};
		background: ${(props) => props.theme.colors.primary.main}15;
		color: ${(props) => props.theme.colors.primary.main};
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: ${(props) => props.theme.spacing.lg};
	}

	h3 {
		font-size: ${(props) => props.theme.typography.sizes.xl};
		font-weight: ${(props) => props.theme.typography.weights.semibold};
		margin-bottom: ${(props) => props.theme.spacing.md};
	}

	p {
		color: ${(props) => props.theme.colors.text.secondary};
		line-height: 1.6;
	}
`;
